<script>
  export let showOffer,
    offerInfo,
    isMostPopular,
    showCurrentPlanOnGroupLevel,
    showUpcomingPlanOnGroupLevel,
    subscription;
</script>

<style lang="scss">
  @use '../index' as *;

  $banner-blue: #edf0f7;

  .highlight-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    top: 0;
    left: 0;
    max-width: 34.1rem;
    min-width: 25.6rem;
    padding: 0.5rem 1.6rem;
    border-radius: 1rem 1rem 0 0;
    box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.05);
    background-color: $banner-blue;
    color: $black;
    font-size: 1.3rem;
    font-weight: 600;

    &.without-highlight-banner {
      background-color: $white;
      box-shadow: 0 -4px 6px 0 rgba(0, 0, 0, 0.05);
    }

    &-and-most-popular {
      border-radius: 0;
      border-inline-start: $black spacing(0.5) solid;
      border-inline-end: $black spacing(0.5) solid;
      box-shadow: none;
    }

    &-with-current-plan {
      border-radius: 0;
    }
  }
</style>

<div
  id={subscription.id}
  class="highlight-banner"
  class:without-highlight-banner={!showOffer || !offerInfo.duration}
  class:highlight-banner-and-most-popular={isMostPopular}
  class:highlight-banner-with-current-plan={showCurrentPlanOnGroupLevel ||
    showUpcomingPlanOnGroupLevel}
>
  {#if showOffer && offerInfo.duration}
    <span>{offerInfo.duration}</span>
  {/if}
</div>
